import PropTypes from 'prop-types';

export default function SetPasswordForm({
  handleSetPasswordSubmit,
  handlePasswordChange,
  handlePasswordConfirmationChange,
  setPasswordDisabled,
  setPasswordValidationState,
}) {
  return (
    <div>
      <h2 className="reset-header">Set your password</h2>
      <form id="setPasswordForm" onSubmit={handleSetPasswordSubmit}>
        <fieldset>
          <label className="text-input-label" htmlFor="resetPassword">
            PASSWORD
            <input type="password" id="resetPassword" onChange={handlePasswordChange} />
          </label>
          <label className="text-input-label" htmlFor="passwordConfirmation">
            PASSWORD CONFIRMATION
            <input type="password" id="passwordConfirmation" onChange={handlePasswordConfirmationChange} />
          </label>
          <div className="submit-container">
            <button
              disabled={setPasswordDisabled}
              className={`icon-arrow-circle ${setPasswordValidationState}`}
              onClick={handleSetPasswordSubmit}
              type="submit"
              id="resetSubmitButton"
              value=""
            >
              <span className="submit-text">Set password&nbsp;</span>
            </button>
          </div>
        </fieldset>
      </form>
    </div>
  );
}

SetPasswordForm.propTypes = {
  handleSetPasswordSubmit: PropTypes.func.isRequired,
  handlePasswordChange: PropTypes.func.isRequired,
  handlePasswordConfirmationChange: PropTypes.func.isRequired,
  setPasswordDisabled: PropTypes.bool.isRequired,
  setPasswordValidationState: PropTypes.string.isRequired,
};
